import api from './api';

export interface SweptPathRequest {
  icao_type: string;
  start_lon: number;
  start_lat: number;
  start_heading_deg: number;
  total_angle_deg: number;
  turn_direction?: 'left' | 'right';
  wake_category?: string;
}

export interface SafetyEnvelopeRequest {
  icao_type: string;
  center_lon: number;
  center_lat: number;
  heading_deg: number;
  mode?: 'icao_minimum' | 'operational';
  wake_category?: string;
}

export interface ConflictCheckRequest {
  aircraft_1_type: string;
  aircraft_1_lon: number;
  aircraft_1_lat: number;
  aircraft_1_heading?: number;
  aircraft_2_type: string;
  aircraft_2_lon: number;
  aircraft_2_lat: number;
  aircraft_2_heading?: number;
  mode?: 'icao_minimum' | 'operational';
}

export interface ConflictCheckResponse {
  has_conflict: boolean;
  actual_separation_m: number;
  required_separation_m: number;
  deficit_m: number;
  aircraft_1: string;
  aircraft_2: string;
  mode: string;
}

export interface JetBlastRequest {
  icao_type: string;
  engine_lon: number;
  engine_lat: number;
  aircraft_heading_deg: number;
  phase?: 'idle' | 'breakaway' | 'taxi' | 'takeoff';
  wake_category?: string;
  multi_engine?: boolean;
}

export interface AircraftDimensions {
  icao_type: string;
  wingspan_m: number;
  length_m: number;
  height_m: number;
  omg_m: number;
  wheelbase_m: number;
  turn_radius_m: number;
  icao_ref: string;
  wake: string;
}

const BASE = '/aircraft-geometry';

export const aircraftGeometryService = {
  async getSweptPath(req: SweptPathRequest): Promise<GeoJSON.Feature> {
    const res = await api.post<GeoJSON.Feature>(`${BASE}/swept-path`, req);
    return res.data;
  },

  async getSafetyEnvelope(req: SafetyEnvelopeRequest): Promise<GeoJSON.Feature> {
    const res = await api.post<GeoJSON.Feature>(`${BASE}/safety-envelope`, req);
    return res.data;
  },

  async checkConflict(req: ConflictCheckRequest): Promise<ConflictCheckResponse> {
    const res = await api.post<ConflictCheckResponse>(`${BASE}/conflict-check`, req);
    return res.data;
  },

  async getJetBlast(req: JetBlastRequest): Promise<GeoJSON.Feature | GeoJSON.FeatureCollection> {
    const res = await api.post<GeoJSON.Feature | GeoJSON.FeatureCollection>(`${BASE}/jet-blast`, req);
    return res.data;
  },

  async getDimensions(icaoType: string): Promise<AircraftDimensions> {
    const res = await api.get<AircraftDimensions>(`${BASE}/dimensions/${icaoType}`);
    return res.data;
  },

  async listTypes(): Promise<{ icao_type: string; wingspan_m: number; wake: string; icao_ref: string }[]> {
    const res = await api.get(`${BASE}/dimensions`);
    return res.data;
  },
};
